<template>
    <div class="payment__form">
        <template
            v-if="state.currentView === 'CARD_INIT_VIEW' && state.processing != true"
        >
            <form
                v-if="state.useSavedCards === false"
                @submit.prevent="checkDetails()"
            >
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("card.title.description") }}
                </p>
                <primary-input
                    :title="$t('card.input.number')"
                    @value-change="collectCardNumber"
                    :total-characters="23"
                    :card="true"
                    @new-focus="handleFocus"
                    :focused="focusedField"
                    type="tel"
                    :number-only="true"
                    @completed-card="handleFocus('expiry')"
                    :isRequired="
                        getValueFromPath(state, 'inputs.cardnumber.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.cardnumber.value') || null
                    "
                    inputName="cardnumber"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="card-number-input"
                    placeholder="0000 0000 0000 0000"
                    :postfix-image="true"
                />
                <div class="container--row card--logo">
                    <div v-for="(card, i) in cardLogos" :key="i">
                        <div v-if="card.svg" v-html="card.svg"></div>
                        <img
                            v-else
                            :src="require(`@/assets/icons/${card.name}.png`)"
                            :alt="`${card.name}`"
                            loading="lazy" 
                        />
                    </div>
                </div>
                <div class="container--row">
                    <div class="container__col-md-7 container__col-sm-7">
                        <primary-input
                            :title="$t('card.input.validity')"
                            @value-change="validTill = $event"
                            :total-characters="5"
                            :date="true"
                            type="tel"
                            :focused="focusedField"
                            @new-focus="handleFocus"
                            @completed-date="handleFocus('cvv')"
                            :number-only="true"
                            inputName="expiry"
                            :isRequired="
                                getValueFromPath(state, 'inputs.expiry.required') || true
                            "
                            :defaultValue="
                                getValueFromPath(state, 'inputs.expiry.value') || null
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="card-number-input"
                            placeholder="MM/YY"
                        />
                    </div>
                    <div class="container__col-md-5 container__col-sm-5">
                        <primary-input
                            title="CVV"
                            :info="$t('card.cvv.info')"
                            :postfix-label-image="'cvv-info-' + state.locale + '.svg'"
                            @value-change="cvv = $event"
                            @show-modal="showCVVInfo"
                            :modalOpen="modalOpen"
                            @new-focus="handleFocus"
                            :total-characters="4"
                            inputName="cvv"
                            :focused="focusedField"
                            :number-only="true"
                            type="password"
                            inputmode="numeric"
                            :isRequired="
                                getValueFromPath(state, 'inputs.cvv.required') || true
                            "
                            :defaultValue="
                                getValueFromPath(state, 'inputs.cvv.value') || null
                            "
                            class="container__col-md-12 container__col-sm-12 cvv"
                            prefix-image="cvv"
                            placeholder="123"
                        />
                    </div>
                    <div
                        class=" container--row container__col-md-12 container__col-sm-12 remember__wrapper"
                    >
                        <label for="" v-if="adaptStateToDevice()" class="checkbox">
                            <span class="checkbox__input">
                                <input
                                    type="checkbox"
                                    v-model="rememberMe"
                                    id="checkbox"
                                    name="checkbox"
                                />
                                <span class="checkbox__control">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="3"
                                            d="M1.73 12.91l6.37 6.37L22.79 4.59"
                                        />
                                    </svg>
                                </span>
                            </span>
                        </label>
                        <label class="" for="checkbox">{{ $t("card.checkbox.remember") }}</label>
                        <div v-if="!adaptStateToDevice()" class="switch">
                            <input
                                id="checkbox"
                                type="checkbox"
                                v-model="rememberMe"
                                class="switch-input"
                            />
                            <label for="checkbox" class="switch-label">{{ $t("card.checkbox.switch") }}</label>
                        </div>
                    </div>
                    <div
                        v-if="rememberMe"
                        class="container__col-md-12 container__col-sm-12"
                    >
                        <div class="container__col-md-12 container__col-sm-12">
                            <primary-input
                                :title="$t('card.input.phone')"
                                type="tel"
                                :number-only="true"
                                inputName="rememberPhone"
                                class="container__col-md-12 container__col-sm-12"
                                prefix-image="smart-phone"
                                placeholder="07013926478"
                                :defaultValue="
                                    getValueFromPath(state, 'inputs.rememberPhone.value') || null
                                "
                                :isRequired="
                                    getValueFromPath(state, 'inputs.rememberPhone.required') ||
                                        true
                                "
                                @value-change="telephone = $event"
                            />
                        </div>
                        <div class="container__col-md-12 container__col-sm-12">
                            <primary-input
                                :title="$t('card.input.email')"
                                class="container__col-md-12 container__col-sm-12"
                                prefix-image="user"
                                placeholder="ted@lade.com"
                                inputName="rememberEmail"
                                type="email"
                                :defaultValue="
                                    getValueFromPath(state, 'inputs.rememberEmail.value') || null
                                "
                                :isRequired="
                                    getValueFromPath(state, 'inputs.rememberEmail.required') ||
                                        true
                                "
                                @value-change="email = $event"
                            />
                        </div>
                    </div>
                </div>
                <PrimaryButton
                    :disabled="!hasCompletedFields"
                    type="submit"
                    :content="
                        [
                            $t('ui.pay.btn'), 
                            state.dcc ? state.dcc.to : state.currency, 
                            formatMoney(resolvedAmount)
                        ]
                            .filter(Boolean)
                            .join(' ')
                    "
                />
                <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                    <button
                        v-if="state.hasSavedCards"
                        type="button"
                        aria-label="Use saved card"
                        class="payment__another"
                        role="button"
                        aria-pressed="false"
                        @click="switchView"
                    >
                        {{ $t("card.saved.description") }}
                    </button>
                </div>
            </form>
            <form
                v-else-if="state.hasSavedCards === true && state.useSavedCards === true"
            >
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("card.preference.description") }}
                </p>
                <ul class="saved-card-list">
                    <li v-for="(card, index) in state.savedCards" :key="index">
                        <button
                            type="button"
                            role="button"
                            aria-label="saved card"
                            class="saved-card"
                            @click="useCard(card)"
                        >
                            <svg v-if="card.brand === 'MASTERCARD'" width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z" fill="#EE0005"/>
                                <path d="M20.1816 18C25.1522 18 29.1816 13.9706 29.1816 9C29.1816 4.02944 25.1522 0 20.1816 0C15.2111 0 11.1816 4.02944 11.1816 9C11.1816 13.9706 15.2111 18 20.1816 18Z" fill="#F9A000"/>
                                <path d="M11.1816 8.99988C11.1816 11.8576 12.5138 14.4039 14.5907 16.0525C16.6675 14.4038 17.9997 11.8576 17.9997 8.99988C17.9997 6.1422 16.6676 3.59586 14.5907 1.94727C12.5138 3.59599 11.1816 6.14226 11.1816 8.99988Z" fill="#FF6300"/>
                            </svg>
                            <svg v-else-if="card.brand === 'VISA'" width="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 613.3"><path d="M732 11 472 604H307L189 131c-7-30-13-40-36-52C116 59 54 40 0 28l4-17h265c34 0 64 22 71 60l61 344L569 11Zm640 399c3-156-218-165-215-235 1-21 22-44 67-49 22-3 84-6 153 26l29-126c-37-13-85-26-145-26-154 0-264 81-266 196-3 86 75 133 134 162 60 29 80 47 80 73-1 40-50 58-94 58-79 1-124-21-160-37l-30 130c36 16 103 31 173 31 164 0 272-79 274-203m404 194h144L1803 11h-133c-30 0-56 17-67 43l-242 550h164l33-89h200Zm-171-210 85-223 44 223ZM955 11 818 604H662L799 11Z" fill="#1434cb"/></svg>
                            <img
                                v-else
                                :src="require('@/assets/icons/othercard.svg')"
                                alt="other card"
                                loading="lazy" 
                                decoding="async"
                            />
                            <label for="saved card"> {{ card.masked_pan }}</label>
                        </button>
                        <button class="remove-btn" type="button" @click="deleteCard(card)">
                            <svg
                                width="24"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.427 7.872h3.147v-1.06h-3.147v1.06Zm12.972-1.979c-.506-2.72-2.642-4.8-5.31-5.307A31.613 31.613 0 0 0 12.002 0c-2.055 0-4.11.187-6.138.586C3.143 1.093 1.088 3.2.58 5.866a32.42 32.42 0 0 0 0 12.214 6.59 6.59 0 0 0 5.285 5.308c2.028.426 4.083.613 6.138.613 2.055 0 4.083-.187 6.112-.587 2.723-.534 4.778-2.614 5.284-5.307.801-4.054.801-8.187 0-12.214ZM16.115 16.88a1.31 1.31 0 0 1-1.309 1.31H9.194a1.31 1.31 0 0 1-1.308-1.31v-6.555a.5.5 0 1 1 1 0v6.555c0 .17.138.31.308.31h5.612a.31.31 0 0 0 .31-.31v-6.555a.5.5 0 1 1 1 0v6.555Zm-5.676-1.214v-5.34a.5.5 0 1 1 1 0v5.34a.5.5 0 1 1-1 0Zm2.123 0v-5.34a.5.5 0 1 1 1 0v5.34a.5.5 0 1 1-1 0Zm4.088-6.793h-9.3a.5.5 0 1 1 0-1h2.077v-1.56a.5.5 0 0 1 .5-.5h4.147a.5.5 0 0 1 .5.5v1.56h2.076a.5.5 0 1 1 0 1Z"
                                    fill="#EB5757"
                                />
                            </svg>
                        </button>
                    </li>
                </ul>
                <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                    <button
                        type="button"
                        class="payment__another"
                        role="button"
                        aria-label="use another card"
                        aria-pressed="false"
                        @click="switchView"
                    >
                        {{ $t("card.select.alternative") }}
                    </button>
                </div>
                <base-modal
                    v-if="showModal"
                    @close="toggleModal"
                    class="modal-container"
                >
                    <div class="modal-header">
                        <svg preserveAspectRatio="xMinYMin meet" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M38.999 9.822c-.845-4.533-4.404-8-8.852-8.845A52.69 52.69 0 0 0 20.006 0C16.58 0 13.155.312 9.775.977c-4.537.845-7.962 4.356-8.808 8.8a54.035 54.035 0 0 0 0 20.357c.845 4.578 4.36 8 8.808 8.845 3.38.71 6.805 1.022 10.23 1.022 3.425 0 6.805-.312 10.186-.978 4.538-.889 7.963-4.356 8.808-8.844a52.245 52.245 0 0 0 0-20.357Z" fill="#F9C8C8"/><path d="M16 14v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-13 0h18-18Zm2 0v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V14H13Zm9 5v6m-4-6v6" stroke="#C91818" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <button type="button" @click="showModal = false">
                            <svg
                                width="16"
                                height="16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 15.384A7.384 7.384 0 1 0 8 .616a7.384 7.384 0 0 0 0 14.768Z"
                                    fill="#F9C8C8"
                                />
                                <path
                                    d="M9.792 10.59a.618.618 0 0 0 .876 0 .62.62 0 0 0 0-.877L8.915 7.96l1.754-1.753a.62.62 0 1 0-.876-.877L8.039 7.084 6.285 5.33a.62.62 0 1 0-.877.877L7.162 7.96 5.41 9.713a.62.62 0 1 0 .877.877l1.753-1.753 1.753 1.753Z"
                                    fill="#C91818"
                                />
                            </svg>
                        </button>
                    </div>
                    <h1>{{ $t("card.delete.btn") }}</h1>
                    <p class="delete-info">
                        {{ $t("card.delete.info") }} {{ selectedCard.masked_pan }}.
                    </p>

                    <p class="delete-question">{{ $t("card.delete.question") }}</p>
                    <div class="modal-cta">
                        <button
                            class="modal-cta-cancel"
                            @click="showModal = false"
                            type="button"
                        >
                            {{ $t("card.delete.cancel") }}
                        </button>
                        <button
                            class="modal-cta-delete"
                            type="button"
                            @click="removeSavedCard(selectedCard)"
                        >
                            {{ $t("card.delete.action") }}
                            <svg
                                width="16"
                                height="16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g
                                    clip-path="url(#a)"
                                    stroke="#fff"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path
                                        d="M5.333 4.001V2.668c0-.737.597-1.334 1.334-1.334h2.666c.737 0 1.334.597 1.334 1.334V4M2 4.001h12H2Zm1.333 0v9.333c0 .737.597 1.334 1.334 1.334h6.666c.737 0 1.334-.597 1.334-1.334V4.001H3.333ZM9.333 7.334v4M6.667 7.334v4"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path
                                            fill="#fff"
                                            transform="translate(0 .001)"
                                            d="M0 0h16v16H0z"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </base-modal>
            </form>
        </template>
        <template  v-else-if="
            state.currentView == 'PAYMOB_INIT_VIEW' && state.processing != true
        ">
            <form @submit.prevent="checkAddress()">
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    Enter your details to pay.
                </p>
                <primary-input
                    :title="$t('card.cardholder.name')"
                    @value-change="cardholdername = $event"
                    :isRequired="getValueFromPath(state, 'inputs.card_holder_name.required') || true"
                    inputName="cardholdername"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="user"
                    placeholder="John Doe"
                    :cardname="true"
                    :postfix-image="false"
                />
                <primary-input
                    :title="$t('card.input.phone')"
                    type="tel"
                    :number-only="true"
                    inputName="telephone"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="smart-phone"
                    placeholder="7013926478"
                    :isRequired="getValueFromPath(state, 'inputs.phonenumber.required') || true"
                    @value-change="telephone = $event"
                />
                <primary-input
                    :title="$t('card.auth.input.address')"
                    @value-change="address = $event"
                    :isRequired="getValueFromPath(state, 'inputs.billing_address.required') || true"
                    inputName="address"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="location"
                    placeholder="20 Saltlake Edorado"
                    :postfix-image="false"
                />
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-input
                            :title="$t('card.auth.input.city')"
                            @value-change="city = $event"
                            :date="false"
                            inputName="city"
                            :isRequired="
                                getValueFromPath(state, 'inputs.billing_city.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="building"
                            placeholder="New Cairo"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('card.auth.input.state')"
                            @value-change="userState = $event"
                            inputName="state"
                            :isRequired="getValueFromPath(state, 'inputs.billing_state.required') || true"
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="state"
                            placeholder="EG-C"
                        />
                    </div>
                </div>
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-select
                            :title="$t('card.auth.input.country')"
                            @value-change="country = $event"
                            inputName="country"
                            :options="state.isoCountryOptions"
                            :for-country="true"
                            :isRequired="
                                getValueFromPath(state, 'inputs.billing_country.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="globe"
                            placeholder="EG"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('card.auth.input.zip')"
                            @value-change="zip = $event"
                            :date="false"
                            inputName="zip"
                            type="tel"
                            :isRequired="getValueFromPath(state, 'inputs.billing_zip.required') || true"
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="zip-code"
                            placeholder="928302"
                        />
                    </div>
                </div>
                <PrimaryButton
                    :content="
                        ['Pay', state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    type="submit"
                    :disabled="!hasCompletedDetails"
                />
            </form>
        </template>
        <form
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
        
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.redirect.description")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </form>
        <form
            v-else-if="
                state.currentView == 'CARD_AUTH_VIEW' && state.auth == 'PIN' && state.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{ $t("card.noauth.input.pin")}}
            </h5>
            <pin-input inputName="" @value-complete="validatePin" :index-value="1" />
        </form>
        <form
            v-if="
                state.currentView == 'CARD_AUTH_VIEW' && state.auth == 'AVS' && state.processing != true
            "
            @submit.prevent="checkAddress()"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.auth.address.title")}}
            </p>
            <primary-input
                :title="$t('card.cardholder.name')"
                @value-change="cardholdername = $event"
                :isRequired="getValueFromPath(state, 'inputs.card_holder_name.required') || true"
                inputName="cardholdername"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="user"
                placeholder="John Doe"
                :cardname="true"
                :postfix-image="false"
            />
            <primary-input
                :title="$t('card.input.phone')"
                type="tel"
                :number-only="true"
                inputName="telephone"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="01 234 56"
                :isRequired="getValueFromPath(state, 'inputs.phonenumber.required') || true"
                @value-change="telephone = $event"
            />
            <primary-input
                :title="$t('card.auth.input.address')"
                @value-change="address = $event"
                :isRequired="getValueFromPath(state, 'inputs.address.required') || true"
                inputName="address"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="location"
                placeholder="20 Saltlake Edorado"
                :postfix-image="false"
            />
            <div class="container--row">
                <div class="container__col-md-8 container__col-sm-8">
                    <primary-input
                        :title="$t('card.auth.input.city')"
                        @value-change="city = $event"
                        :date="false"
                        inputName="city"
                        :isRequired="
                            getValueFromPath(state, 'inputs.city.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="building"
                        placeholder="Livingson"
                    />
                </div>
                <div class="container__col-md-4 container__col-sm-4">
                    <primary-input
                        :title="$t('card.auth.input.state')"
                        @value-change="userState = $event"
                        inputName="state"
                        :isRequired="getValueFromPath(state, 'inputs.cvv.required') || true"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="state"
                        placeholder="CA"
                    />
                </div>
            </div>
            <div class="container--row">
                <div class="container__col-md-8 container__col-sm-8">
                    <!-- <primary-input
                        title="COUNTRY"
                        @value-change="country = $event"
                        inputName="country"
                        :isRequired="
                            getValueFromPath(state, 'inputs.country.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="globe"
                        placeholder="US"
                    /> -->
                    <primary-select
                        :title="$t('card.auth.input.country')"
                        :description-text="$t('ui.input.choose')"
                        @value-change="country = $event"
                        inputName="country"
                        :options="state.isoCountryOptions"
                        :for-country="true"
                        :isRequired="
                            getValueFromPath(state, 'inputs.country.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="globe"
                        placeholder="US"
                    />
                </div>
                <div class="container__col-md-4 container__col-sm-4">
                    <primary-input
                        :title="$t('card.auth.input.zip')"
                        @value-change="zip = $event"
                        :date="false"
                        inputName="zip"
                        :isRequired="getValueFromPath(state, 'inputs.zip.required') || true"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="zip-code"
                        placeholder="928302"
                    />
                </div>
            </div>
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
            />
        </form>
        <form
            v-else-if="
                state.currentView == 'CARD_OTP_VIEW' && state.processing !== true
            "
            @submit.prevent="submitOtp"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.otp.instruction")}}
            </p>
            <primary-input
                :title="$t('card.otp.input.pin')"
                class="container__col-md-12 container__col-sm-12 card-otp"
                prefix-image="password"
                placeholder="123456"
                type="password"
                input-name="otp"
                inputmode="numeric"
                :isRequired="getValueFromPath(state, 'inputs.otp.required') || true"
                @value-change="otp = $event"
            />
            <PrimaryButton :content="$t('card.otp.confirm.btn')" type="submit" />

            <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                <button
                    :disabled="!state.canResendOtp"
                    type="button"
                    aria-label="resend OTP"
                    :class="state.canResendOtp === false ? 'resend-disabled' : 'payment__another'"
                    role="button"
                    aria-pressed="false"
                    @click="resendOtp"
                >
                    {{ $t("card.otp.resend.btn")}}
                </button>
            </div>
        </form>

        <form
            v-else-if="
                state.currentView == 'CARD_MOBILE_NUMBER_VIEW' && state.processing !== true
            "
            @submit.prevent="submitPhoneForOTP"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ state.instructions }}
            </p>
            <div class="container__col-md-12 container__col-sm-12">
                <primary-input
                    :title="$t('card.input.phone')"
                    type="tel"
                    :number-only="true"
                    inputName="phoneForOTP"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="smart-phone"
                    placeholder="07013926478"
                    :defaultValue="null"
                    :isRequired="true"
                    @value-change="phoneForOTP = $event"
                />
            </div>
            <PrimaryButton content="Authorize Payment" type="submit" />
        </form>

        <section v-if="!adaptStateToDevice() && modalOpen" class="cvv-info__popup">
            <svg class="cvv-info__img" width="279" height="145" viewBox="0 0 279 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="264.904" height="145" rx="9.62172" fill="#FFE596"/>
                <rect y="19.5192" width="264.904" height="29.2788" fill="#F2C94C"/>
                <rect x="25.0962" y="65.5289" width="203.558" height="26.4904" fill="white"/>
                <circle cx="249.406" cy="78.1766" r="27.2616" fill="white" stroke="#F2C94C" stroke-width="4.00905"/>
                <path d="M239.133 72.0382H241.411V83.022H243.548V85.0159H236.16V83.022H238.652V76.4798C238.652 76.1594 238.661 75.8241 238.679 75.474L238.154 75.9191C237.946 76.103 237.726 76.2395 237.495 76.3285C237.269 76.4175 237.044 76.462 236.818 76.462C236.534 76.462 236.261 76.3967 235.999 76.2662C235.738 76.1356 235.501 75.9369 235.287 75.6698L235.092 75.4295L239.133 72.0382ZM250.937 75.7588C250.937 75.2426 250.812 74.8569 250.563 74.6017C250.32 74.3465 249.946 74.1982 249.441 74.1567C249.002 74.1211 248.608 74.2872 248.258 74.6551C248.169 74.756 248.088 74.8658 248.017 74.9844C247.798 75.3405 247.572 75.6016 247.341 75.7677C247.109 75.9339 246.857 76.017 246.584 76.017C246.501 76.017 246.415 76.0081 246.326 75.9903L245.009 75.7499C245.104 75.1031 245.285 74.5394 245.552 74.0587C245.825 73.5781 246.16 73.1775 246.557 72.8571C246.961 72.5367 247.421 72.2993 247.937 72.145C248.453 71.9848 249.008 71.9047 249.602 71.9047C250.242 71.9047 250.818 71.9996 251.328 72.1895C251.845 72.3735 252.284 72.6316 252.646 72.9639C253.008 73.2962 253.284 73.6938 253.474 74.1567C253.669 74.6136 253.767 75.118 253.767 75.6698C253.767 76.1445 253.699 76.5837 253.563 76.9872C253.432 77.3907 253.251 77.7764 253.02 78.1443C252.788 78.5063 252.518 78.8593 252.21 79.2035C251.901 79.5418 251.578 79.8859 251.239 80.236L249.005 82.5236H252.957C253.26 82.5236 253.5 82.6126 253.678 82.7906C253.856 82.9686 253.945 83.209 253.945 83.5116V85.0159H244.831V83.5205L249.05 79.2747C249.37 78.9543 249.649 78.6487 249.886 78.3579C250.124 78.0672 250.32 77.7823 250.474 77.5034C250.628 77.2186 250.744 76.9367 250.821 76.6578C250.898 76.373 250.937 76.0733 250.937 75.7588ZM256.75 81.0371C257.249 81.0371 257.727 81.3457 258.184 81.9628C258.308 82.1349 258.439 82.2773 258.575 82.3901C259.014 82.7342 259.436 82.9063 259.839 82.9063C260.148 82.9063 260.415 82.8559 260.64 82.755C260.872 82.6482 261.062 82.5147 261.21 82.3545C261.364 82.1883 261.48 82.0014 261.557 81.7937C261.634 81.586 261.673 81.3754 261.673 81.1617C261.673 80.8828 261.652 80.6336 261.61 80.4141C261.575 80.1886 261.468 79.9957 261.29 79.8355C261.112 79.6753 260.842 79.5536 260.48 79.4705C260.124 79.3815 259.625 79.337 258.985 79.337V77.4322C259.525 77.4322 259.961 77.3907 260.293 77.3076C260.625 77.2245 260.881 77.1118 261.059 76.9694C261.243 76.821 261.364 76.643 261.423 76.4353C261.483 76.2276 261.513 75.9992 261.513 75.7499C261.513 75.2396 261.388 74.848 261.139 74.575C260.895 74.2961 260.522 74.1567 260.017 74.1567C259.809 74.1567 259.62 74.1863 259.447 74.2457C259.275 74.305 259.121 74.3851 258.985 74.486C258.848 74.5869 258.732 74.7055 258.637 74.842C258.59 74.9073 258.546 74.9755 258.504 75.0468C258.118 75.7707 257.655 76.1327 257.115 76.1327C256.973 76.1327 256.831 76.1119 256.688 76.0704L255.584 75.7499C255.679 75.1031 255.86 74.5394 256.127 74.0587C256.4 73.5781 256.736 73.1775 257.133 72.8571C257.537 72.5367 257.997 72.2993 258.513 72.145C259.029 71.9848 259.584 71.9047 260.177 71.9047C260.818 71.9047 261.388 71.9967 261.886 72.1806C262.385 72.3587 262.806 72.6019 263.15 72.9105C263.494 73.2191 263.756 73.5781 263.934 73.9875C264.112 74.391 264.201 74.8183 264.201 75.2693C264.201 75.6787 264.159 76.0407 264.076 76.3552C263.993 76.6638 263.868 76.9338 263.702 77.1652C263.542 77.3907 263.34 77.5835 263.097 77.7438C262.86 77.904 262.587 78.0375 262.278 78.1443C263.714 78.6428 264.432 79.6189 264.432 81.0727C264.432 81.7611 264.307 82.3604 264.058 82.8707C263.809 83.3811 263.474 83.8053 263.052 84.1436C262.637 84.4818 262.153 84.737 261.602 84.9091C261.05 85.0752 260.474 85.1583 259.875 85.1583C259.258 85.1583 258.709 85.093 258.228 84.9625C257.747 84.826 257.32 84.6183 256.946 84.3394C256.572 84.0546 256.243 83.6926 255.958 83.2535C255.679 82.8144 255.436 82.2922 255.228 81.6869L255.967 81.2596C256.228 81.1113 256.489 81.0371 256.75 81.0371Z" fill="#4F4F4F"/>
            </svg>
            <h4 class="cvv-info__main">{{ $t("card.cvv.title") }}</h4>
            <p class="cvv-info__sub">
                {{ $t("card.cvv.instruction")}}
            </p>
            <div class="cvv-info__btn-wrapper">
                <button @click="modalOpen = false" type="button" class="cvv-info__btn">
                    {{ $t("card.cvv.close.btn")}}
                </button>
            </div>
        </section>
    </div>
</template>

<script>
import { ref, onBeforeUnmount, watch, computed, provide } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, formatMoney, isValidPhoneNumber } from "@/support/helpers";

import PrimaryInput from "@/components/form/base-input";
import PrimaryButton from "@/components/form/base-button.vue";
import PinInput from "@/components/form/base-pin-input";
import BaseModal from "@/components/base-modal";
import PrimarySelect from "@/components/form/base-select";
import { useI18n } from "vue-i18n";

export default {
    name: "CardPayment",
    components: {
        PinInput,
        PrimaryButton,
        PrimaryInput,
        BaseModal,
        PrimarySelect,
    },
    emits: ["error-message"],
    // eslint-disable-next-line vue/no-setup-props-destructure
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = injectStore();
        const transactionSuccessful = ref(false);
        const cardNumber = ref("");
        const validTill = ref("");
        const cvv = ref("");
        const pin = ref("");
        const checkoutData = ref(store.getState());
        const email = ref("");
        const telephone = ref("");
        const otp = ref("");
        const phoneForOTP = ref("");
        const address = ref("");
        const city = ref("");
        const cardholdername = ref("");
        const userState = ref("");
        const zip = ref("");
        const country = ref("");
        const focusedField = ref("cardnumber");
        const modalOpen = ref(false);
        const cardError = ref(false);
        const errorMessage = ref("");
        const selectedCard = ref();
        const showModal = ref(false);
        const rememberMe = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.remember.value",
            ) || false,
        );
        const cardLogos = [
            {
                "name": "card-discover",
            },
            {
                "name": "card-visa",
                "svg": "<svg width=\"24\" height=\"16\" viewBox=\"0 0 24 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"0.322646\" y=\"0.274062\" width=\"22.7471\" height=\"14.5253\" rx=\"1.72594\" fill=\"white\" stroke=\"#E0E0E0\" stroke-width=\"0.548123\"/>\r\n<path d=\"M8.45117 10.8627L9.53593 4.66846H11.2921L10.2074 10.8627H8.45117Z\" fill=\"#293688\"/>\r\n<path d=\"M16.4595 4.82883C16.1114 4.70329 15.5661 4.56885 14.8852 4.56885C13.1495 4.56885 11.9269 5.40918 11.9164 6.61311C11.9068 7.50296 12.7891 7.99932 13.4557 8.29586C14.1393 8.59888 14.3692 8.79331 14.3659 9.06411C14.3616 9.47931 13.8197 9.66911 13.3147 9.66911C12.6119 9.66888 12.2383 9.57516 11.6614 9.34399L11.4351 9.2453L11.1885 10.632C11.5988 10.8049 12.3576 10.955 13.1453 10.9625C14.9912 10.9621 16.1901 10.1322 16.2036 8.84619C16.2103 8.14163 15.7423 7.60542 14.7289 7.16321C14.1149 6.87702 13.7389 6.68588 13.7429 6.39542C13.7429 6.13804 14.0614 5.86273 14.7488 5.86273C15.3232 5.85405 15.7393 5.97444 16.0637 6.09997L16.2208 6.17142L16.4595 4.82883Z\" fill=\"#293688\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5442 5.19599C18.7291 4.79272 19.0331 4.66846 19.4539 4.66846L19.454 4.66863H20.7972L22.2434 10.863H20.5904L20.384 9.91375H18.1624L17.8009 10.863H15.9414L18.5442 5.19599ZM19.355 6.94317C19.355 6.94317 18.8006 8.31775 18.6555 8.67446V8.67463H20.1134L19.7069 6.88601L19.588 6.35223C19.5407 6.47644 19.4745 6.64122 19.4247 6.76531C19.3813 6.8735 19.3503 6.95074 19.355 6.94317Z\" fill=\"#293688\"/>\r\n<path d=\"M5.24855 8.91554L5.09385 8.06635C4.77332 7.07647 3.77854 6.00543 2.66382 5.46881L4.21548 10.8637H6.07535L8.86462 4.66943H7.00517L5.24855 8.91554Z\" fill=\"#293688\"/>\r\n<path d=\"M1.14917 4.66895V4.76897C3.3529 5.28152 4.88285 6.57731 5.48855 8.06592L4.85174 5.19758C4.74544 4.80559 4.42329 4.6826 4.04211 4.669L1.14917 4.66895Z\" fill=\"#F7981D\"/>\r\n</svg>\r\n",
            },
            {
                "name": "card-amex",
                "svg": "<svg width=\"25\" height=\"16\" viewBox=\"0 0 25 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.825195 2C0.825195 0.895429 1.72063 0 2.8252 0H22.1204C23.225 0 24.1204 0.895431 24.1204 2V13.0734C24.1204 14.178 23.225 15.0734 22.1204 15.0734H2.82519C1.72063 15.0734 0.825195 14.178 0.825195 13.0734V2Z\" fill=\"#016FD0\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.9704 2.94001L21.5476 1.37061H24.1873V2.30266H22.1491L21.2231 4.74396L20.9765 5.4054L20.724 4.74396L19.7919 2.30266H17.7535V7.1131L15.6369 2.30266H13.9954L11.8667 7.1131H13.2618L13.6346 6.18709H15.9676L16.3405 7.1131H17.7535H18.9802V3.9803L18.9742 3.34893L19.2147 3.9803L20.3872 7.1131H21.5538L22.7323 3.9803L22.9608 3.35495V7.1131H24.1873V8.99533L22.8285 10.3601L24.1873 11.743V13.7034H21.698L20.778 12.627L19.8219 13.7034H12.7505V7.97293H10.4175L13.3338 1.37061H16.172L16.8575 2.86786V1.37061H20.3811L20.9704 2.94001ZM14.8011 3.33089L14.5606 3.9322L14.0615 5.14684H15.5407L15.0416 3.9322L14.8011 3.33089ZM13.7368 12.7714V7.97898H17.7535V9.01924H14.9635V9.86107H17.6994V10.8953H14.9635V11.7311H17.7535V12.7714H13.7368ZM17.7535 12.7714H19.3049L20.7661 11.208L22.2212 12.7714H23.8147L21.5658 10.3662L23.8147 7.97898H22.2453L20.7961 9.53636L19.353 7.97898H17.7535L19.9964 10.3842L17.7535 12.7714Z\" fill=\"white\"/></svg>",
            },
            {
                "name": "card-mastercard",
                "svg": "<svg width=\"24\" height=\"16\" viewBox=\"0 0 24 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"0.668457\" width=\"23.2952\" height=\"15.0734\" rx=\"2\" fill=\"#222222\"/>\r\n<g clip-path=\"url(#clip0_12342_36525)\">\r\n<path d=\"M15.5823 2.71729H10.4004V12.0282H15.5823V2.71729Z\" fill=\"#FF5F00\"/>\r\n<path d=\"M10.7294 7.37283C10.7294 5.48103 11.6177 3.80309 12.9831 2.71737C11.9796 1.92775 10.7129 1.45068 9.33108 1.45068C6.05745 1.45068 3.40894 4.0992 3.40894 7.37283C3.40894 10.6465 6.05745 13.295 9.33108 13.295C10.7129 13.295 11.9796 12.8179 12.9831 12.0283C11.6177 10.959 10.7294 9.26463 10.7294 7.37283Z\" fill=\"#EB001B\"/>\r\n<path d=\"M22.5737 7.37283C22.5737 10.6465 19.9251 13.295 16.6515 13.295C15.2697 13.295 14.003 12.8179 12.9995 12.0283C14.3813 10.9426 15.2532 9.26463 15.2532 7.37283C15.2532 5.48103 14.3649 3.80309 12.9995 2.71737C14.003 1.92775 15.2697 1.45068 16.6515 1.45068C19.9251 1.45068 22.5737 4.11565 22.5737 7.37283Z\" fill=\"#F79E1B\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_12342_36525\">\r\n<rect width=\"19.1837\" height=\"12.3324\" fill=\"white\" transform=\"translate(3.40894 1.37061)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>",
            },
            {
                "name": "card-verve",
                "svg": "<svg width=\"25\" height=\"16\" viewBox=\"0 0 25 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_12342_36528)\">\r\n<path d=\"M23.1669 0H1.72494C1.01795 0 0.444824 0.573129 0.444824 1.28012V13.7933C0.444824 14.5003 1.01795 15.0734 1.72494 15.0734H23.1669C23.8739 15.0734 24.4471 14.5003 24.4471 13.7933V1.28012C24.4471 0.573129 23.8739 0 23.1669 0Z\" fill=\"#00425F\"/>\r\n<path d=\"M5.44585 10.5851C7.48311 10.5851 9.13463 8.93355 9.13463 6.89629C9.13463 4.85904 7.48311 3.20752 5.44585 3.20752C3.4086 3.20752 1.75708 4.85904 1.75708 6.89629C1.75708 8.93355 3.4086 10.5851 5.44585 10.5851Z\" fill=\"#EE312A\"/>\r\n<path d=\"M5.44569 8.47674C4.62066 6.60647 4.01564 4.85938 4.01564 4.85938H2.75073C2.75073 4.85938 3.52062 7.10188 4.95067 9.90626H5.94071C7.37076 7.10188 8.14065 4.85938 8.14065 4.85938H6.87574C6.87574 4.85938 6.27072 6.60647 5.44569 8.47674Z\" fill=\"white\"/>\r\n<path d=\"M23.1043 8.24433H20.6296C20.6296 8.24433 20.6846 9.06941 21.7845 9.06941C22.3344 9.06941 22.8844 8.90427 22.8844 8.90427L22.9944 9.78417C22.9944 9.78417 22.4444 10.0042 21.6745 10.0042C20.5746 10.0042 19.5847 9.4542 19.5847 7.91437C19.5847 6.70448 20.3546 5.93457 21.4545 5.93457C23.1043 5.93457 23.2144 7.5844 23.1043 8.24433ZM21.3995 6.70448C20.6846 6.70448 20.6296 7.4744 20.6296 7.4744H22.1694C22.1694 7.4744 22.1144 6.70448 21.3995 6.70448Z\" fill=\"white\"/>\r\n<path d=\"M14.6008 6.93622L14.7658 6.0563C14.7658 6.0563 13.4917 5.66966 12.4561 6.38627V9.90585H13.556L13.5559 7.0462C13.9958 6.71624 14.6008 6.93622 14.6008 6.93622Z\" fill=\"white\"/>\r\n<path d=\"M11.5954 8.24433H9.12061C9.12061 8.24433 9.17559 9.06941 10.2755 9.06941C10.8254 9.06941 11.3753 8.90427 11.3753 8.90427L11.4854 9.78417C11.4854 9.78417 10.9354 10.0042 10.1655 10.0042C9.06558 10.0042 8.07568 9.4542 8.07568 7.91437C8.07568 6.70448 8.84562 5.93457 9.94553 5.93457C11.5954 5.93457 11.7053 7.5844 11.5954 8.24433ZM9.8905 6.70448C9.17559 6.70448 9.12061 7.4744 9.12061 7.4744H10.6604C10.6604 7.4744 10.6055 6.70448 9.8905 6.70448Z\" fill=\"white\"/>\r\n<path d=\"M17.2721 8.58741C16.9303 7.75591 16.6544 6.89877 16.4472 6.02393L15.3474 6.02407C15.3474 6.02407 15.8973 8.14731 16.8323 9.90665H17.712C18.6469 8.14731 19.1969 6.02446 19.1969 6.02446H18.0971C17.8898 6.89911 17.614 7.75608 17.2721 8.58741Z\" fill=\"white\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_12342_36528\">\r\n<rect width=\"24.0022\" height=\"15.0734\" fill=\"white\" transform=\"translate(0.444824)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>",
            },
            {
                "name": "card-dinersclub",
                "svg": "<svg width=\"25\" height=\"16\" viewBox=\"0 0 25 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"1.20228\" y=\"0.274062\" width=\"22.7471\" height=\"14.5253\" rx=\"1.72594\" fill=\"white\" stroke=\"#E0E0E0\" stroke-width=\"0.548123\"/><path d=\"M6.61011 7.6191C6.61011 5.06049 8.68356 2.98975 11.2395 2.98975C13.7954 2.98975 15.8688 5.0632 15.8688 7.6191C15.8688 10.175 13.7954 12.2485 11.2395 12.2485C8.68356 12.2485 6.61011 10.175 6.61011 7.6191Z\" fill=\"white\"/><path d=\"M11.2475 12.3328C8.594 12.3464 6.40942 10.1943 6.40942 7.57878C6.40942 4.71931 8.594 2.74072 11.2475 2.74072H12.4916C15.1125 2.74072 17.5058 4.7166 17.5058 7.57878C17.5058 10.1943 15.1125 12.3328 12.4916 12.3328H11.2475ZM11.2583 3.13644C8.83252 3.13644 6.86748 5.10148 6.86748 7.52728C6.86748 9.95308 8.83252 11.9181 11.2583 11.9181C13.6841 11.9181 15.6492 9.95308 15.6492 7.52728C15.6492 5.10148 13.6841 3.13644 11.2583 3.13644ZM10.2609 10.1238V4.93072C9.21739 5.33186 8.47746 6.34284 8.47474 7.52728C8.47746 8.71172 9.21739 9.7227 10.2609 10.1238ZM14.0419 7.52728C14.0419 6.34013 13.2992 5.32915 12.253 4.93072V10.1266C13.2965 9.72541 14.0392 8.71443 14.0419 7.52999\" fill=\"#0B4F94\"/></svg>",
            },
            {
                "name": "card-afrigo",
                "svg": "<svg width=\"24\" height=\"16\" viewBox=\"0 0 24 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"0.978896\" y=\"0.274062\" width=\"22.7471\" height=\"14.5253\" rx=\"1.72594\" fill=\"white\" stroke=\"#E0E0E0\" stroke-width=\"0.548123\"/><circle cx=\"18.4133\" cy=\"7.72531\" r=\"4.14182\" fill=\"#00AA4F\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.67024 6.13232H4.04677L4.09101 6.21922L4.09053 6.22019L4.13351 6.30616L5.63962 9.31839H5.1762L4.74171 8.4494H2.99619L2.56962 9.31834H2.1062L3.67024 6.13232ZM3.19525 8.0439H4.53896L3.86094 6.68787L3.19525 8.0439Z\" fill=\"#00AA4F\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.2771 6.07471V6.13269V6.4802V9.31871H6.74052V7.8127H8.01495V7.40721H6.74052V6.4802H8.82591V6.07471H6.2771Z\" fill=\"#00AA4F\"/><rect x=\"13.1128\" y=\"6.13232\" width=\"0.46342\" height=\"3.18601\" fill=\"#00AA4F\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.7334 7.98627H17.5733C17.6022 8.56547 17.2125 8.9709 16.5886 8.9709C15.8847 8.9709 15.3721 8.45826 15.3721 7.75442C15.3721 7.05059 15.8847 6.48002 16.5886 6.48002C17.0472 6.48002 17.4123 6.72224 17.6111 7.08573L17.935 6.84973C17.6438 6.41699 17.1494 6.13232 16.5885 6.13232C15.6927 6.13232 14.9666 6.85851 14.9666 7.7543C14.9666 8.65008 15.6927 9.37627 16.5885 9.37627C17.4842 9.37627 18.0076 8.82607 18.0077 7.98627H18.0078V7.58078H16.7334V7.98627ZM21.8599 7.75448C21.8599 8.65027 21.1338 9.37645 20.238 9.37645C19.3422 9.37645 18.616 8.65027 18.616 7.75448C18.616 6.85869 19.3422 6.13251 20.238 6.13251C21.1338 6.13251 21.8599 6.85869 21.8599 7.75448ZM21.4255 7.75461C21.4255 8.45844 20.9418 9.00005 20.238 9.00005C19.5342 9.00005 19.0215 8.45844 19.0215 7.75461C19.0215 7.05077 19.5342 6.4802 20.238 6.4802C20.9418 6.4802 21.4255 7.05077 21.4255 7.75461Z\" fill=\"white\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.6595 7.91308C12.0909 7.83378 12.4177 7.45583 12.4177 7.00155C12.4177 6.48967 12.0028 6.07471 11.4909 6.07471L11.4691 6.07496H9.57915V6.13251H9.5791V9.31853H10.0425V7.92847H11.2051L12.0122 9.31853H12.4756L11.6595 7.91308ZM10.0425 6.48045V7.52298H10.1005V7.52316H10.9697L10.9695 7.52277H11.4329L11.4331 7.52316H11.4441L11.444 7.52295L11.4451 7.52295C11.7178 7.52295 11.939 7.27438 11.939 7.0016C11.939 6.72883 11.7178 6.48026 11.4451 6.48026L11.4313 6.48047H10.7243L10.7243 6.48045H10.0425Z\" fill=\"#00AA4F\"/></svg>",
            },
        ];
        
        const focusedPin = ref(1);

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const hasCompletedFields = computed(() => {
            let completed = false;
            if (cardNumber.value != "" && validTill.value != "" && cvv.value != "") {
                completed = true;
                // if( rememberMe.value){if(email.value != "" & telephone.value != "") { } }
                // else{
                //     completed = true;
                // }
            }
            return completed;
        });
        const hasCompletedAddress = computed(() => {
            let completed = false;
            if (address.value != "" && city.value != "" && userState.value != "" && zip.value != "" && country.value != "") {
                completed = true;
            }
            return completed;
        });
        const hasCompletedDetails = computed(() => {
            let completed = false;
            if (address.value != "" && city.value != "" && userState.value != "" && zip.value != "" && country.value != "" && cardholdername.value && telephone.value != "") {
                completed = true;
            }
            return completed;
        });

        const resolvedAmount = computed(() => {
            if (checkoutData.value?.campaign && checkoutData.value?.campaign?.new_amount) {
                return checkoutData.value.campaign.new_amount;
            } 
            else if (checkoutData.value?.dcc?.charge_amount) {
                return checkoutData.value.dcc.charge_amount;
            } 
            else {
                return checkoutData.value?.amount.toLocaleString();
            }
        });

        function checkDetails() {
            if (hasCompletedFields.value) {
                cardError.value = false;
                errorMessage.value = "";
                if (isValidCardNumber(cardNumber.value.split(" ").join(""))) {
                    cardError.value = false;
                    errorMessage.value = "";
                    if (isValidExpiry(validTill.value)) {
                        cardError.value = false;
                        errorMessage.value = "";
                        if (rememberMe.value) {
                            cardError.value = false;
                            errorMessage.value = "";
                            const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
                            if (email.value == "" || telephone.value == "") {
                                cardError.value = `true-${new Date().getTime()}`;
                                errorMessage.value = "Please fill all input fields correctly.";
                                return;
                            }
                            else if (!email.value.match(EMAIL_REGEX)) {
                                cardError.value = `true-${new Date().getTime()}`;
                                errorMessage.value = t("card.invalid.email");
                                return;
                            }
                            else {
                                step2();
                            }
                        }
                        else step2();
                    } 
                    else {
                        cardError.value = `true-${new Date().getTime()}`;
                        errorMessage.value = t("card.invalid.date");
                        return;
                    }
                }
                else {
                    cardError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("card.invalid.cardnumber");
                    return;
                }
            }
        }

        function isValidCardNumber(cardNumber) {
            return !_luhnoffset(cardNumber);
        }

        function isValidExpiry(expiryDate) {
            const date = new Date();
            const year = Number(String(date.getFullYear()).substring(2));
            let month = Number(String((date.getMonth()) + 1));
            let day = new Date().getDay() + 1;
  
            const plusTenYears = Number(String(new Date(year + 10, month, day).getFullYear()).substring(2));
  
            let expiryYear = Number(expiryDate.split("/")[1]);
            let expiryMonth = Number(expiryDate.split("/")[0]);

            if (expiryMonth > 12) {
                return false;
            }

            if (expiryYear > plusTenYears) {
                return false;
            }

            if (year > expiryYear) {
                return false;
            }

            if (year === expiryYear) {
                // Current year => check if month entered is in the past
                if (expiryMonth < month) {
                    return false;
                }
            }

            return true;
        }

        function checkAddress() {
            let data = {
                billing_address: address.value, 
                billing_city: city.value, 
                billing_country: country.value, 
                billing_state: userState.value, 
                billing_zip: zip.value,
                card_holder_name: cardholdername.value,
                phonenumber: telephone.value,
            };

            let trimmedPhoneNumber = data.phonenumber.replace(/\s/g, "").replace(/[()]/g, "");
            // eslint-disable-next-line no-useless-escape
            const specialChars = /[`!@#$%^&*()_+\\=\[\]{};':"\\|<>\\?~]/;
            if (specialChars.test(data.billing_address)) {
                cardError.value = "true-address";
                errorMessage.value = "Address should not contain only special characters.";
            }
            else if (specialChars.test(data.billing_city)) {
                cardError.value = "true-city";
                errorMessage.value = "City should not contain only special characters.";
            }
            else if (specialChars.test(data.billing_state)) {
                cardError.value = "true-state";
                errorMessage.value = "State should not contain only special characters.";
            }
            // else if (specialChars.test(data.card_holder_name)) {
            //     cardError.value = "true-cardholdername";
            //     errorMessage.value = "Cardholder name should not contain only special characters.";
            // }
            else if (!isValidPhoneNumber(trimmedPhoneNumber, 5)) {
                cardError.value = "true-phonenumber";
                errorMessage.value = "Phone number can not be less than 5 digits.";
            }
            else {
                cardError.value = false;
                data.phonenumber = trimmedPhoneNumber;
                errorMessage.value = "";
                updateRuntimeData(data);
            }
        }

        function switchView() {
            checkoutData.value.view.context.$actions.switch();
        }
        function useCard(card) {
            checkoutData.value.view.context.$actions.update({ savedcard: card });
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        watch(rememberMe, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                checkoutData.value.view.context.$actions.update({ remember: newVal });
            }
        });
        watch(cardError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("error-message", errorMessage.value);
            }
        });
        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                cardError.value = false;
            }
        });
        function submitOtp() {
            checkoutData.value.view.context.$actions.update({ otp: otp.value });
            Next();
        }
        function submitPhoneForOTP() {
            checkoutData.value.view.context.$actions.update({ otp: phoneForOTP.value });
            Next();
        }

        function step2() {
            const data = {
                cardnumber: (cardNumber.value || "").replace(/\s+/g, ""),
                cvv: cvv.value,
                expiry: validTill.value,
            };
            if (rememberMe.value === true) {
                data.rememberEmail = email.value;
                data.rememberPhone = telephone.value;
            }
            updateRuntimeData(data);
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function showCVVInfo(e) {
            if (e) {
                modalOpen.value = e;
            }
            else {
                modalOpen.value = false;
            }
        }
        function _luhnoffset(cardNumber) {
            return (_luhnsum(cardNumber) * 9) % 10;
        }
        function _luhnsum(cardNumber) {
            const digits = Array.from(String(cardNumber), Number);
            const checkDigit = digits.pop();

            return digits.reverse().reduce((sum, digit, index) => {
                if (++index & 1) {
                    (digit <<= 1) > 9 && (digit -= 9);
                }

                return sum + digit;
            }, checkDigit);
        }
        function toggleModal() {
            showModal.value = !showModal.value;
        }
        function removeSavedCard(card) {
            toggleModal();
            checkoutData.value.view.context.removeSavedCard(card.hash);
        }
        function deleteCard(card) {
            toggleModal();
            this.selectedCard = card;
        }
        function resendOtp() {
            checkoutData.value.view.context.resendOTP();
        }
        function validatePin(e) {
            pin.value = e;
            checkoutData.value.view.context.$actions.update({ pin: pin.value });
            Next();
        }
        function handleFocus(e) {
            if (e === "cvv") {
                if (cardNumber.value && cardNumber.value.length >= 16) {
                    focusedField.value = e;
                }
            } 
            else focusedField.value = e;
        }
        function collectCardNumber(e) {
            cardNumber.value = e;
            const data = {
                cardnumber: (cardNumber.value || "").replace(/\s+/g, ""),
            };
            if (data.cardnumber.length === 6 || data.cardnumber.length >= 13 || cardNumber.value === "") {
                checkoutData.value.view.context.$actions.update(data);
            }
            if (data.cardnumber.length < 6) {
                checkoutData.value.view.context.removeCardType();
            }
        }
        function updateRuntimeData(data) {
            checkoutData.value.view.context.$actions.update(data);
            Next();
        }

        provide(
            "cardError",
            computed(() => errorMessage.value),
        );
        onBeforeUnmount(() => {
            cardError.value = false;
            errorMessage.value = "";
            emit("error-message", errorMessage.value);
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                dcc: (state) => getValueFromPath(state, "dcc") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                auth: (state) => getValueFromPath(state, "view.context.auth") || null,
                hasSavedCards: (state) =>
                    getValueFromPath(state, "view.context.hasSavedCard") || false,
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instructions") || null,
                useSavedCards: (state) =>
                    getValueFromPath(state, "view.context.useSavedCard") || false,
                savedCards: (state) =>
                    getValueFromPath(state, "view.context.$cards") || [],
                canResendOtp: (state) =>
                    getValueFromPath(state, "view.context.canResendOTP") || false,
                isoCountryOptions: (state) =>
                    getValueFromPath(state, "view.context.inputs.billing_country.options") || [], 
                locale: (state) => getValueFromPath(state, "locale") || "en",
            }),
            step2,
            checkoutData,
            cardNumber,
            validTill,
            cvv,
            pin,
            otp,
            phoneForOTP,
            country,
            city,
            userState,
            zip,
            address,
            telephone,
            email,
            cardholdername,
            cardError,
            deleteCard,
            errorMessage,
            hasCompletedFields,
            hasCompletedAddress,
            hasCompletedDetails,
            useCard,
            focusedField,
            handleFocus,
            collectCardNumber,
            updateRuntimeData,
            removeSavedCard,
            resendOtp,
            switchView,
            submitOtp,
            submitPhoneForOTP,
            checkDetails,
            checkAddress,
            rememberMe,
            isValidCardNumber,
            focusedPin,
            validatePin,
            showCVVInfo,
            modalOpen,
            showModal,
            selectedCard,
            toggleModal,
            transactionSuccessful,
            getValueFromPath,
            formatMoney,
            Next,
            cardLogos,
            resolvedAmount,
        };
    },
};
</script>

<style lang="scss" scoped>
.email-error {
  font-size: 12px;
  color: red;
  margin-bottom: 10px;
}
.checkbox {
  margin-right: 8px;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-size: 2rem;
  color: #FF9B00;
}

.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid currentColor;

  svg {
    transition: transform 0.1s ease-in 25ms;
    transform: scale(0);
    transform-origin: bottom left;
  }
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";

  > * {
    grid-area: checkbox;
  }

  input {
    opacity: 0;
    z-index: 999;
    width: 1em;
    height: 1em;
    &:focus + .checkbox__control {
      box-shadow: 0 0 0 0.05em #fff, 0 0 0.15em 0.1em currentColor;
    }

    &:checked + .checkbox__control svg {
      transform: scale(1);
    }
  }
}
.switch {
  position: relative;
  display: inline-block;
}
.switch-input {
  display: none;
}
.switch-label {
  display: block;
  width: 4.2rem;
  height: 2.3rem;
  text-indent: -150%;
  clip: rect(0 0 0 0);
  color: transparent;
  user-select: none;
}
.switch-label::before,
.switch-label::after {
  content: "";
  display: block;
  position: absolute;
  cursor: pointer;
}
.switch-label::before {
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  border-radius: 9999em;
  -webkit-transition: background-color 0.25s ease;
  transition: background-color 0.25s ease;
}
.switch-label::after {
  top: 0.13rem;
  left: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: $white;
  box-shadow: 0px 5.06671px 5.06671px rgba(0, 0, 0, 0.15);
  // box-shadow: 0 0 2px rgba(0, 0, 0, 0.45);
  -webkit-transition: left 0.25s ease;
  transition: left 0.25s ease;
}
.switch-input:checked + .switch-label::before {
  background-color: $primary-color;
}
.switch-input:checked + .switch-label::after {
  left: 2.4rem;
}
.modal-container {
  .modal {
    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.5rem;
      @include screen(menner) {
        margin-bottom: 3.2rem;
      }
      svg{
          width: 2rem;
      }
    }
    &-cta {
      display: flex;
      justify-content: flex-end;
      font-weight: $font-medium;
      font-size: 1.4rem;
      line-height: 1.7rem;
      &-cancel {
        text-align: center;
        letter-spacing: 0.0024px;
        color: $sub-color;
        margin-right: 1.6rem;
        border: 1.5px solid #12122c;
        box-sizing: border-box;
        border-radius: 0.4rem;
        padding: 1.15rem 2.2rem;
      }
      &-delete {
        color: $white;
        background: #eb5757;
        border-radius: 0.4rem;
        padding: 1.15rem 2.2rem;
      }
    }
  }
  .delete-question {
    margin-bottom: 4.8rem;
  }
  .delete-info {
    margin-bottom: 2rem;
  }
  h1 {
    font-weight: $font-semi-bold;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 16px;
    @include screen(menner) {
      font-size: 2rem;
      line-height: 2.4rem;
    }
  }
  p {
    font-size: 1.4rem;
    line-height: 2rem;
    @include screen(menner) {
      font-size: 1.6rem;
      line-height: 2.4rem;
    }
  }
}
.saved-card {
  width: 88%;
  margin-top: 2.5rem;
  background: #ffffff;
  border: 1px solid #d2dce8;
  box-sizing: border-box;
  border-radius: 0.6rem;
  padding: 1.9rem 0 1.9rem 2.8rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  & img {
    margin-right: 3.2rem;
  }
  &:focus {
    border: 1px solid $primary-color;
  }
}
.remember__wrapper {
  display: flex;
  margin-bottom: 3rem;
  color: $secondary-text-color;
  font-weight: $font-normal;
  font-size: 1.4rem;
  @media screen and (max-width: 576px) {
    justify-content: space-between;
  }
}
.payment__another {
  width: 190px;
  margin: 0;
  cursor: pointer;
  margin: 0 auto;
  font-size: 1.4rem;
  line-height: 1.4rem;
  text-align: center;
  letter-spacing: 0.3px;
  color: $primary-color;
  background: $white;
  border: none;

  &:focus {
    border: 0.1em solid currentColor;
    outline: $primary-color;
  }
  &:disabled{
    opacity: 0.4;
}
  &.otp {
    &:hover {
      text-decoration: underline;
    }
    &:disabled{
       opacity: 0.4;
    }
  }
}
.another-saved, .otp{
    margin: 2rem 0 0px; 
}
.cvv-info {
  &__popup {
    @media screen and (max-width: 576px) {
      height: 100vh;
      z-index: 999;
      overflow: hidden;
      background: $primary-text-color;
      padding: 30vh 5rem 0 5rem;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      color: white;
    }
  }
  &__img {
    margin: 0 auto;
    margin-bottom: 2.7rem;
  }
  &__main {
    font-family: $font-primary;
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0.55rem;
    border-bottom: 1px dashed #7c7c7c;
  }
  &__sub {
    font-family:  $font-primary;
    margin-top: 1.71rem;
    margin-bottom: 3.4rem;
    font-size: 1.4rem;
    font-style: italic;
    line-height: 1.8rem;
    color: #e0e0e0;
  }

  &__btn {
    font-family: $font-primary;
    background: $primary-color;
    border-radius: 0.539683rem;
    font-size: 1.78947rem;
    line-height: 105%;
    color: white;
    font-weight: $font-bold;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.9rem 1.8rem;
    border: none;
    &-wrapper {
      display: flex;
      justify-content: center;
    }
  }
}
.remove-btn {
  border: none;
  background: transparent;
  margin: 2.7rem 0 0 0;
  &:focus {
    border: 1px solid $primary-color;
  }
}
.saved-card-list {
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.resend-disabled {
    color: rgba(51, 51, 51, 0.4);
    font-weight: $font-semi-bold;
    cursor: not-allowed;
    margin: 0 auto;
}
.card--logo {
    margin-top: -30px;
    margin-bottom: 30px;
    padding: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5.4px;
    border-radius: 0px 0px 4px 4px;

    img {
        width: 100%;
        height: 15px;
    }
}
</style>